<template>
  <v-container fluid>
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            :disabled="isSearch"
            primary
            @click.native="addItem()"
          >
            Pridėti klasifikatorių
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.kla_reiksme`]="{ item }">
        <div :class="item.reiksme_class">
          {{ item.kla_reiksme }}
        </div>
      </template>
      <template #[`item.kla_darbo_vieta`]="{ item }">
        <el-busena
          :busena="item.kla_darbo_vieta_label"
          :color="item.kla_darbo_vieta_color"
        />
      </template>
      <template #[`item.kla_savitarna`]="{ item }">
        <el-busena
          :busena="item.kla_savitarna_label"
          :color="item.kla_savitarna_color"
        />
      </template>
      <template #[`item.galioja_label`]="{ item }">
        <el-busena :busena="item.galioja_label" :color="item.galioja_color" />
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          class="mb-3"
          :item="item"
          @editItem="editItem(item)"
          @viewItem="viewItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-klasifikatorius
      :key="modalKlasifikatoriusKey"
      :readonly="modalKlasifikatoriusReadonly"
      v-model="showKlasifikatorius"
      :item="modalKlasifikatorius"
      @savedData="savedKlasifikatorius"
      @canceledData="canceledKlasifikatorius"
    />
  </v-container>
</template>

<script>
import ModalKlasifikatorius from '../modals/ModalKlasifikatorius'

export default {
  name: 'AdminKlasifikatoriaiDetail',
  components: { ModalKlasifikatorius },
  props: {
    grupe: Number,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: [],
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
      modalKlasifikatorius: {},
      modalKlasifikatoriusReadonly: false,
      showKlasifikatorius: false,
      modalKlasifikatoriusRefresh: 0,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Reikšmė',
          align: 'start',
          sortable: true,
          value: 'kla_reiksme',
        },
        {
          text: 'Rodoma darbo vietoje',
          align: 'center',
          sortable: true,
          value: 'kla_darbo_vieta',
        },
        {
          text: 'Rodoma el. paslaugose',
          align: 'center',
          sortable: true,
          value: 'kla_savitarna',
        },
        {
          text: 'Galioja',
          align: 'start',
          sortable: true,
          value: 'galioja_label',
        },
        {
          text: 'Galioja nuo',
          align: 'start',
          sortable: true,
          value: 'kla_galioja_nuo',
        },
        {
          text: 'Galioja iki',
          align: 'start',
          sortable: true,
          value: 'kla_galioja_iki',
        },
        {
          text: 'Pakeitimo data',
          align: 'start',
          sortable: true,
          value: 'atnaujinimo_data',
        },
        {
          text: 'Pakeitimą atlikęs asmuo',
          align: 'start',
          sortable: true,
          value: 'busena_pakeite',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        item.klg_id = this.grupe
        item.reiksme_class = item.galiojantis ? '' : 'kla_negalioja'
        item.galioja_label = item.galiojantis ? 'Taip' : 'Ne'
        item.galioja_color = item.galiojantis ? 'green' : 'default'
        item.kla_darbo_vieta_label = item.kla_darbo_vieta ? 'Taip' : 'Ne'
        item.kla_darbo_vieta_color = item.kla_darbo_vieta ? 'green' : 'default'
        item.kla_savitarna_label = item.kla_savitarna ? 'Taip' : 'Ne'
        item.kla_savitarna_color = item.kla_savitarna ? 'green' : 'default'
        item.yraGaliojaNuo = item.kla_galioja_nuo ? true : false
        item.yraGaliojaIki = item.kla_galioja_iki ? true : false

        item.canEdit = item.redaguojamas
        item.canView = !item.canEdit
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    modalKlasifikatoriusKey() {
      return 'klasif' + this.modalKlasifikatoriusRefresh
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/klasifikatorius/${this.grupe}`)
        .then(res => {
          this.formData = res.data.klasifikatoriai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    addItem() {
      this.openKlasifikatorius({
        klg_id: this.grupe,
        kla_darbo_vieta: false,
        kla_savitarna: false,
      })
    },
    editItem(item) {
      this.openKlasifikatorius(item)
    },
    viewItem(item) {
      this.openKlasifikatorius(item, true)
    },
    openKlasifikatorius(item, readonly = false) {
      if (item) {
        this.modalKlasifikatorius = {
          ...item,
        }
      } else {
        this.modalKlasifikatorius = {}
      }

      this.modalKlasifikatoriusReadonly = readonly
      this.modalKlasifikatoriusRefresh++
      this.showKlasifikatorius = true
    },
    savedKlasifikatorius() {
      this.getData()
    },
    canceledKlasifikatorius() {
      //
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/color.scss';

.reiksme {
  width: 100%;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
  line-height: 50px;
}
.kla_negalioja {
  color: $disabledText;
}
</style>
